import DefaultFormFooter from './DefaultFormFooter';
import StarFormFooter from './StarFormFooter';
import TiFormFooter from './TiFormFooter';
import generateRender from 'shared/utils/generateRender';

const FormFooter = generateRender({
  default: DefaultFormFooter,
  ti: TiFormFooter,
  star: StarFormFooter
})

export default FormFooter;